import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { DEFAULT_CARLEAD_CONFIGS } from '@wkda/marketing-components';

export default generateCarleadCreationConfig({
  ...DEFAULT_CARLEAD_CONFIGS['de-AT'],
  step2Path: '/{currentPath}/step-2/',
});

